String.prototype.toHtmlId = function () {
    return this.split('[').join('-').split(']').join('');
};

String.prototype.removeSpaces = function () {
    return this.replace(/\s+/g, '');
};

String.prototype.toNumber = function () {
    return Number(this.removeSpaces());
};

String.prototype.toCurrency = function () {
    let value = this.split('.'),
        entier = value[0],
        mantissa = value.length > 1 ? '.' + value[1] : '',
        rgx = /(\d+)(\d{3})/;
    while (rgx.test(entier)) {
        entier = entier.replace(rgx, '$1' + ' ' + '$2');
    }
    return entier + mantissa;
};

// TODO: Существует проблема с видимостью свойств-функций прототипов (видимы там, где не нужны), подумать над созданием функции, которая делает ее невидимой на основе defineProp с атрибутом iteratable = false